import {Component} from "@angular/core";

@Component({
    selector: "fui-page-content-section",
    styleUrls: ["./page-content-section.component.scss"],
    templateUrl: "./page-content-section.component.html",
    standalone: false
})
export class FUIPageContentSectionComponent {

}
